import React from 'react';

import styled from 'styled-components';

import { FeeDataType, FeeType } from 'types/fees';

const Container = styled.div`
  display: flex;
  font-size: 12px;
  color: var(--text-secondary);
  text-align: justify;
  width: 70%;
`;

type Props = {
  fee?: FeeDataType;
};

const FeesNote = ({ fee }: Props) => {
  const feeTypeSegment = fee?.fee_type === FeeType.MEDICATION_FEE ? 'medication' : 'care';

  return <Container data-test-id={`cd-community-${feeTypeSegment}-fees-levels-note`}>{fee?.fee_note}</Container>;
};

export default FeesNote;
